/**
 * Sidebar cookie name and parse rule.
 *
 * Deliberately NOT in client-sidebar-context.tsx. That file is `"use client"`,
 * and a plain value imported from a client module into a server component is
 * replaced by Next with a client-reference stub - a function that throws when
 * called. TypeScript still reports it as `string`, so the substitution is
 * invisible to tsc and the lint rules: the root layout read
 * `cookies().get(SIDEBAR_COLLAPSED_COOKIE)` for months, silently matched
 * nothing, and pinned the rail collapsed for everyone.
 *
 * Keep shared constants that both sides read in a module with no "use client".
 */

export const SIDEBAR_COLLAPSED_COOKIE = "spark-sidebar-collapsed";

/** Collapsed is the default, so an absent or unrecognised cookie means collapsed. */
export function isSidebarCollapsed(cookieValue: string | undefined | null): boolean {
  return cookieValue !== "0";
}

/** The value to persist for a given state. */
export function sidebarCollapsedCookieValue(collapsed: boolean): string {
  return collapsed ? "1" : "0";
}
